import { render, staticRenderFns } from "./KitchenForm.vue?vue&type=template&id=07861739&scoped=true&"
import script from "./KitchenForm.vue?vue&type=script&lang=js&"
export * from "./KitchenForm.vue?vue&type=script&lang=js&"
import style0 from "./KitchenForm.vue?vue&type=style&index=0&id=07861739&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07861739",
  null
  
)

export default component.exports